<template>
  <div>
    <a-tabs type="card" default-active-key="1">
      <a-tab-pane key="1" tab="一般检查结果">
        <div class="border" v-for="(item, index) in chartData" :key="index">
          <div class="title">{{ item.name }}</div>
          <MultiLineChart 
            v-if="chartList[`${item.id}`]"
            :unit-name="item.id"
            :chart-data="chartList[`${item.id}`]"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane v-if="chartList['xdt'].length" key="2" tab="心电图">
        <div class="resItem" v-for="(item, index) in chartList['xdt']" :key="index">
          <div class="ltitle">{{ item.peResult }}</div>
          <div>{{ item.appDate }}</div>
        </div>
      </a-tab-pane>
      <a-tab-pane v-if="chartList['yg'].length" key="3" tab="乙肝">
        <div class="resItem" v-for="(item, index) in chartList['yg']" :key="index">
          <div class="ltitle">{{ item.peResult }}</div>
          <div>{{ item.appDate }}</div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import MultiLineChart from './MultiLineChart'
export default {
  components: {
    MultiLineChart
  },
  props: {
    chartList: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartData: [
        {
          id: 'sgChart',
          name: '身高'
        },
        {
          id: 'tzChart',
          name: '体重'
        },
        {
          id: 'tzzsChart',
          name: '体重指数'
        },
        {
          id: 'xyChart',
          name: '血压'
        },
      ]
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.title {
  font-size: 18px;
  color: #333;
}

.resItem {
  display: flex;
  align-items: center;
  width: 955px;
  height: 53px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(71,133,230,0.25);
  border-radius: 5px;
  justify-content: space-between;
  padding: 0 40px;
  margin: 0 auto 30px;
}

.border {
  border: 1px solid #F0F0F0;
  padding: 10px;
  margin-bottom: 10px;
}

</style>
